import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import './../css/navbar.css';
import dk_logo from '../assets/icon-defensek.png';

const Navbar = () => {

  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedMode = localStorage.getItem('darkMode');
    return savedMode === 'true';
  });

  const toggleDarkMode = () => {
    setIsDarkMode(prevMode => {
      const newMode = !prevMode;
      localStorage.setItem('darkMode', newMode);
      return newMode;
    });
  };

  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [isDarkMode]);


  return (
    <nav className="navbar">
      <div className="logo">
        <a href='https://defensek.com'><img src={dk_logo} alt="DefenseK Logo" /></a>
      </div>
      <ul className="nav-links">
        <li><Link to="home" smooth={true} duration={500}>Home</Link></li>
        <li><Link to="about" smooth={true} duration={500}>About</Link></li>
        <li><Link to="services" smooth={true} duration={500}>Services</Link></li>
        <li><a href="https://defensek.medium.com" target="_blank" rel="noopener noreferrer" smooth={true} duration={500}>Community</a></li>
        <button onClick={toggleDarkMode} className="toggle-btn">{isDarkMode ? '☀️' : '🌙'}</button>
      </ul>
        <a href='mailto:contact@defensek.com'><button className="cta-button">Contact us</button></a>
    </nav>
  );
};

export default Navbar;
